import { runCommand } from '../../services/appwrite/command-gateway';

export interface NotificationCountGateway {
  count(): Promise<number>;
}

/**
 * Cantidad de notificaciones de la cuenta actual.
 *
 * Es una capacidad global: la usa la cabecera en todas las superficies y el
 * panel solo consume la misma consulta ya cacheada por TanStack Query.
 */
export const notificationCountGateway: NotificationCountGateway = {
  async count() {
    const result = await runCommand<{ count: number }>('count_notifications');
    return result.count;
  },
};
